// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1fWoz","tab":"Tabs_tab__1-Th9","tabActive":"Tabs_tabActive__wGEoX"};